import Modal from "react-modal";
import { useDispatch, useSelector } from "react-redux";

import { clearMinorError } from "shared/actions/slideDetailActions";

import ApplicationState from "store/ApplicationState";

const ErrorModal = () => {
  const dispatch = useDispatch();
  const { minorError } = useSelector(
    ({ slideDetail }: ApplicationState) => slideDetail
  );

  return (
    <Modal
      isOpen={minorError !== undefined}
      onRequestClose={() => {
        dispatch(clearMinorError());
      }}
      contentLabel="Error"
      className="Modal"
      overlayClassName="Overlay"
    >
      <div className="AnnotationEditBox">
        <h6>ERROR</h6>
        {minorError}
        <div className="AnnotationEditBox_Buttons">
          <button
            type="submit"
            onClick={() => {
              dispatch(clearMinorError());
            }}
          >
            OK
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ErrorModal;
